module.exports = __webpack_public_path__ + "img/702_2.37a63cb5.jpg";